import axios from "axios";
import { getStorageItem, clearStorage } from "@/utils/storage";
import { showMessage, showStepNotification } from "./message";
import { ACCESS_TOKEN } from "@/store/types";
import store from "@/store";
import router from "@/router";

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000 // 请求超时时间
});
// 异常拦截处理器
const errorHandler = error => {
  if (error.response) {
    if (error.response.status === 401) {
      showMessage("error", "未授权请重新登录");
      // 退出返回登录页
      store.dispatch("Logout").then(() => {
        router.push({ name: "Login" });
      });
    } else {
      showMessage("error", error.response.status);
    }
  }
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use(config => {
  const token = getStorageItem(ACCESS_TOKEN);
  // config obj
  // adapter: ƒ xhrAdapter(config)
  // baseURL: "/api"
  // data: undefined
  // headers: {Accept: "application/json, text/plain, */*"}
  // maxContentLength: -1
  // method: "get"
  // params: {__ob__: Observer}
  // timeout: 5000
  // transformRequest: [ƒ]
  // transformResponse: [ƒ]
  // url: "/oauth/token"
  // validateStatus: ƒ validateStatus(status)
  // xsrfCookieName: "XSRF-TOKEN"
  // xsrfHeaderName: "X-XSRF-TOKEN"
  if (config.url === "/user/login" || config.url === "/user/loginAddSmsCode") {
    config.headers["Authorization"] = "Basic Y2xpZW50aWQ6c2VjcmV0";
  } else {
    config.headers["Authorization"] = token;
  }
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use(response => {
  if (response.data.code === 0) {
    if (response.data.message) {
      showMessage("error", response.data.message);
    }
    return Promise.reject(response.data);
  } else if (response.data.code === 2) {
    if (response.data) {
      showStepNotification(response.data);
    }
    return Promise.reject(response.data);
  } else if (response.data.code === 3) {
    // 清除缓存
    clearStorage();
    showMessage("error", "请先登录");
    router.push({ name: "Login" });
  } else if (response.data.code === 4) {
    // 清除缓存
    clearStorage();
    showMessage("error", "登录已过期，请重新登录");
    router.push({ name: "Login" });
  }
  return response.data;
}, errorHandler);

export default request;
